var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2286_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.751648,
    y: -0.00341797,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2286_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75165 20.9966C7.20165 20.9966 6.73081 20.8007 6.33915 20.4091C5.94748 20.0174 5.75165 19.5466 5.75165 18.9966V5.99658C5.46831 5.99658 5.23081 5.90075 5.03915 5.70908C4.84748 5.51742 4.75165 5.27992 4.75165 4.99658C4.75165 4.71325 4.84748 4.47575 5.03915 4.28408C5.23081 4.09242 5.46831 3.99658 5.75165 3.99658H9.75165C9.75165 3.71325 9.84748 3.47575 10.0391 3.28408C10.2308 3.09242 10.4683 2.99658 10.7516 2.99658H14.7516C15.035 2.99658 15.2725 3.09242 15.4641 3.28408C15.6558 3.47575 15.7516 3.71325 15.7516 3.99658H19.7516C20.035 3.99658 20.2725 4.09242 20.4641 4.28408C20.6558 4.47575 20.7516 4.71325 20.7516 4.99658C20.7516 5.27992 20.6558 5.51742 20.4641 5.70908C20.2725 5.90075 20.035 5.99658 19.7516 5.99658V18.9966C19.7516 19.5466 19.5558 20.0174 19.1641 20.4091C18.7725 20.8007 18.3016 20.9966 17.7516 20.9966H7.75165ZM17.7516 5.99658H7.75165V18.9966H17.7516V5.99658ZM10.7516 16.9966C11.035 16.9966 11.2725 16.9007 11.4641 16.7091C11.6558 16.5174 11.7516 16.2799 11.7516 15.9966V8.99658C11.7516 8.71325 11.6558 8.47575 11.4641 8.28408C11.2725 8.09242 11.035 7.99658 10.7516 7.99658C10.4683 7.99658 10.2308 8.09242 10.0391 8.28408C9.84748 8.47575 9.75165 8.71325 9.75165 8.99658V15.9966C9.75165 16.2799 9.84748 16.5174 10.0391 16.7091C10.2308 16.9007 10.4683 16.9966 10.7516 16.9966ZM14.7516 16.9966C15.035 16.9966 15.2725 16.9007 15.4641 16.7091C15.6558 16.5174 15.7516 16.2799 15.7516 15.9966V8.99658C15.7516 8.71325 15.6558 8.47575 15.4641 8.28408C15.2725 8.09242 15.035 7.99658 14.7516 7.99658C14.4683 7.99658 14.2308 8.09242 14.0391 8.28408C13.8475 8.47575 13.7516 8.71325 13.7516 8.99658V15.9966C13.7516 16.2799 13.8475 16.5174 14.0391 16.7091C14.2308 16.9007 14.4683 16.9966 14.7516 16.9966Z",
    fill: "#292A3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.1f6a4b85199325c24556b279cd794a8c.svg";
export { ForwardRef as ReactComponent };